var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Form'),_c('div',{staticClass:"container"},[_c('footer',{staticClass:"py-3 my-4"},[_c('p',{staticClass:"text-center text-muted"},[_vm._v(" ©"+_vm._s(_vm.currentYear)+" Water Tower Dog Park ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }